import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import PurchaseOrderService from "../../Controller/PurchaseOrderController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import HelpSite from "../../../Common/HelpLink";

function PurchaseOrderAddress({ PurchaseOrderID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [CountryList, setCountries] = useState([]);
    const [formData, setFormData] = useState({
        vc_SupplierName: "",
        Supp_Address1: "",
        Supp_Address2: "",
        Supp_Address3: "",
        Supp_City: "",
        Supp_County: "",
        Supp_Country: "",
        Supp_Phone: "",
        Supp_Postcode: "",
        Supp_Email: ""
    });
    const { theme } = useContext(ThemeContext);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        fetchCountries();
        if (PurchaseOrderID > 0) {
            fetchPurchaseOrderDetail();
        }
        else {
            resetForm();
        }
    }, [PurchaseOrderID]);
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const fetchPurchaseOrderDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (PurchaseOrderID > 0) {
                const purchaseOrderDetail = await PurchaseOrderService.GetPurchaseOrderByID(redirectCallback, PurchaseOrderID);
                const purchaseOrder = purchaseOrderDetail[0];
                setFormData({
                    ...purchaseOrder,
                });
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };


    const resetForm = () => {

        setFormData({
            vc_SupplierName: "",
            Supp_Address1: "",
            Supp_Address2: "",
            Supp_Address3: "",
            Supp_City: "",
            Supp_County: "",
            Supp_Country: "",
            Supp_Phone: "",
            Supp_Postcode: "",
            Supp_Email: ""
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <form>
                <div className="row mb-3" style={{ marginRight: "5px", marginTop: "10px" }}>
                    <table style={{ width: "100%" }}>
                        <tbody>


                            <tr>
                                <td style={{width:"13%"}}><label htmlFor="vc_SupplierName" style={{ float: "right" }}>Supplier Name <span style={{ "color": "red" }}>*</span></label></td>
                                <td style={{width:"37%"}}>
                                    <input type="text" className="form-control" name="vc_SupplierName" value={formData.vc_SupplierName} />
                                </td>
                                <td style={{width:"13%"}}>

                                </td>
                                <td style={{width:"13%"}}></td>
                            </tr>
                            <tr>
                                <td><label htmlFor="Supp_Address1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="Supp_Address1" value={formData.Supp_Address1} />

                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="Supp_Address2" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="Supp_Address2" value={formData.Supp_Address2} />

                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="Supp_Address3" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="Supp_Address3" value={formData.Supp_Address3} />

                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="Supp_City" style={{ float: "right" }}>Town/City <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="Supp_City" value={formData.Supp_City} />

                                </td>
                                <td><label htmlFor="Supp_County" style={{ float: "right" }}>County <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="Supp_County" value={formData.Supp_County} />

                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="Supp_Postcode" style={{ float: "right" }}>Post Code <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="Supp_Postcode" value={formData.Supp_Postcode} />

                                </td>
                                <td><label htmlFor="Supp_Phone" style={{ float: "right" }}>Telephone <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="Supp_Phone" value={formData.Supp_Phone} />

                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="Supp_Email" style={{ float: "right" }}>Email <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="Supp_Email" value={formData.Supp_Email} />

                                </td>
                                <td><label htmlFor="Supp_Country" style={{ float: "right" }}>Country <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <select name="Supp_Country" className='form-control' value={formData.Supp_Country} >
                                        <option value="0">Select Country</option>
                                        {CountryList.map((country) => (
                                            <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                {country.vc_CountryName}
                                            </option>
                                        ))}
                                    </select>

                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </form>


        </div>


    );
}
export default PurchaseOrderAddress;

